import $store from '../store';
import { DOMAIN_TITLE, SITE_URL } from '../config/env';

// export function guardRoute(to, from, next) {
//   // const isAppRoute = to.path('/office');
//   const isAdminRoute = to.matched.some(item => item.meta.adminAuth);
//   let isAdmin = $store.state.userRole === 'admin' || $store.state.userRole === 'referent';
//   if (isAdminRoute) {
//     if (isAdmin) return next();
//     return next(false);
//   }
//   if (!$store.state.isLoggedIn && to == '/office') {
//     console.log('test guardroute for office');
//     setTimeout(() => {
//       return window.location.href = SITE_URL;
//     }, 100);
//     // next('/');
//     // return window.location.href = SITE_URL;
//   }
//   next();
// }

// export function guardRoute(to, from, next) {
// console.log(to);
// console.log(from);
// console.log(next);
// }

/*
export function guardRoute(to, from, next) {
    console.log("guardRoute");
    
  const isAdminRoute = to.matched.some(item => item.meta.adminAuth);
  let isAdmin = $store.state.userRole === 'admin' || $store.state.userRole === 'referent';
  if (isAdminRoute) {
    if (isAdmin) return next();
    return next(false);
  }
  next();
};*/

export function updatePageTitle(to, from, next) {
    let pageTitle = to.matched.find(item => item.meta.title);
    (pageTitle)
        ? window.document.title = pageTitle.meta.title
        : window.document.title = DOMAIN_TITLE;
    next();
}



// WEBPACK FOOTER //
// ./src/router/middlewares.js